import React from 'react'
import './TournamentInstagramVideos.css'

const INSTAGRAM_VIDEOS = [
    'https://www.instagram.com/reel/DH6lwtIIhU6/embed/',
    'https://www.instagram.com/p/DJg0vDqIDpM/embed/',
    'https://www.instagram.com/p/DM97sHIsRBR/embed/',
]

/** Instagram Reels icon (play in rounded square) for overlay */
const InstagramReelsIcon: React.FC = () => (
    <div className="instagram-reels-icon-overlay" aria-hidden>
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="instagram-reels-icon"
        >
            <rect
                x="2"
                y="2"
                width="20"
                height="20"
                rx="4"
                fill="rgba(0,0,0,0.5)"
                stroke="white"
                strokeWidth="1.5"
            />
            <path d="M10 8l6 4-6 4V8z" fill="white" />
        </svg>
    </div>
)

const TournamentInstagramVideos: React.FC = () => {
    return (
        <section
            className="tournament-instagram-section"
            id="tournament-instagram"
        >
            <div className="tournament-instagram-videos">
                {INSTAGRAM_VIDEOS.map((embedUrl, index) => (
                    <div
                        key={index}
                        className="tournament-instagram-video-wrapper"
                    >
                        <InstagramReelsIcon />
                        <iframe
                            src={embedUrl}
                            title={`Instagram ${index + 1}`}
                            className="tournament-instagram-iframe"
                            // frameBorder="0"
                            style={{
                                width: "100%",
                                height: "700px",
                                border: "none",
                                overflow: "hidden"
                            }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                ))}
            </div>
        </section>
    )
}

export default TournamentInstagramVideos
